/**
 * инфа https://app.nuclino.com/Pimpay-Kassa/Main/Operation-38318b0c-9980-4597-b704-4557b9d5820d
 */

const INVOICE_SCHEMA = [
  {
    code: 1,
    name: "InvoiceCreated",
    reasonMessage: "Счет создан"
  },
  {
    code: 3,
    name: "InvoicePayed",
    reasonMessage: "Счет оплачен"
  },
  {
    code: 4,
    name: "InvoiceFailed",
    reasonMessage: "Ошибка при оплате счета"
  },
  {
    code: 8,
    name: "InvoiceCancelled",
    reasonMessage: "Счет отменен"
  },
  {
    code: 6,
    name: "InvoicePartlyRefunded",
    reasonMessage: "По счету выполнен частичный возврат"
  },
  {
    code: 7,
    name: "InvoiceRefunded",
    reasonMessage: "По счету выполнен возврат"
  },
  {
    code: 10,
    name: "InvoicePreAuthorized",
    reasonMessage: "Средства захолдированы"
  },
];

function getReasonOperationStatusMessage({ code }) {
  return INVOICE_SCHEMA.find(option => option.code === code);
}

export default {
  INVOICE_SCHEMA,
  getReasonOperationStatusMessage,
}

